import { render, staticRenderFns } from "./virtualSimulationClassAdd.vue?vue&type=template&id=476ef324&scoped=true"
import script from "./virtualSimulationClassAdd.vue?vue&type=script&lang=js"
export * from "./virtualSimulationClassAdd.vue?vue&type=script&lang=js"
import style0 from "./virtualSimulationClassAdd.vue?vue&type=style&index=0&id=476ef324&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ef324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476ef324')) {
      api.createRecord('476ef324', component.options)
    } else {
      api.reload('476ef324', component.options)
    }
    module.hot.accept("./virtualSimulationClassAdd.vue?vue&type=template&id=476ef324&scoped=true", function () {
      api.rerender('476ef324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/virtualSimulationClass/virtualSimulationClassAdd.vue"
export default component.exports